import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<BasicUi::LoaderFullscreen />",{ moduleName: "mewe/templates/confirm-account.hbs" })